<div class="row">
  <inspection-validations
    [inspection]="inspection"
    [validatedPlugins]="validatedPlugins"
    (toggleCancel)="cancel()"
  ></inspection-validations>
</div>
